import fileDownload from "js-file-download";
import { checkAndUpdateToken } from "./auth";
import {
  GET_STUDENT_RESULT_FILE_COMPLETED,
  GET_STUDENT_RESULT_FILE_FAILED,
  GET_STUDENT_RESULT_FILE_STARTED,
} from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";

export const getStudentResultFile = (
  filename,
  userId,
  sheId,
  instance
) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: GET_STUDENT_RESULT_FILE_STARTED });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/homework/userresult/${userId}/${sheId}/${instance}/${filename}`,
      {
        ...buildDefaultHeaders(getState),
      }
    );

    if (response.ok) {
      const data = await response.blob();
      fileDownload(data, filename);
      dispatch({ type: GET_STUDENT_RESULT_FILE_COMPLETED });
    } else {
      dispatch({ type: GET_STUDENT_RESULT_FILE_FAILED });
    }
  }
};
